import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { initialDecisionListFilter } from 'DecisionListPackage/DecisionListFiltersModule/constants/initialDecisionListFilter';
import { IDecisionListFilter } from 'DecisionListPackage/DecisionListFiltersModule/interfaces/IDecisionListFilter';
import { mapDecisionFilterToRaw } from 'DecisionListPackage/DecisionListFiltersModule/common/mapDecisionFilterToRaw';

import { IDecisionListFilterRaw } from '../interfaces/IDecisionListFilterRaw';

export function getRawFilter(): IDecisionListFilterRaw {
  const current = getStorageItem<IDecisionListFilter>(StorageNamesEnum.DECISION_FILTER);
  const isFilterOn = !!getStorageItem(StorageNamesEnum.DECISION_FILTER_ON);
  const rawFilterData = mapDecisionFilterToRaw((isFilterOn && current) || initialDecisionListFilter);

  return {
    ...rawFilterData,
  };
}
